import React from "react";
import { Button } from "@mui/material";
import { useGoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";
import jwtDecode from "jwt-decode";
import { getCurrentUser, createGoogleUser } from "../firebase";
import { UserMaster } from "../types";

interface Props {
    setUser: (user: UserMaster) => void;
}

const GoogleLogin = (props: Props) => {
    const handleGoogleResponse = async (response: any) => {
        const token = response.access_token;
        fetch(
            "https://www.googleapis.com/oauth2/v1/userinfo?alt=json&access_token=" +
                token
        ).then((response) => {
            response.json().then(async (credential) => {
                try {
                    const user = await getCurrentUser(credential.id.toString());
                    props.setUser(user);
                } catch (err: any) {
                    if (err.message === "No user found") {
                        // create new user
                        const newUser = await createGoogleUser(
                            credential.email,
                            credential.id.toString(),
                            credential.name
                        );
                        props.setUser({
                            ...newUser,
                            _protectedRouteRedirect: "/user-wizard",
                        });
                    }
                }
            });
        });
    };

    const login = useGoogleLogin({
        onSuccess: handleGoogleResponse,
    });

    return (
        <>
            <Button
                variant="contained"
                color="blue"
                style={{
                    maxWidth: "15rem",
                    margin: "0 auto",
                    textTransform: "none",
                }}
                onClick={() => {
                    login();
                }}
            >
                Sign in with Google
            </Button>
        </>
    );
};

export default GoogleLogin;
